import React from "react";
import Home from "./Home";
import { Row, Col, Card, Icon, CardTitle, Modal, Button } from "react-materialize";
import Slider from "react-slick";
import StarRatings from "react-star-ratings";
import { CheckAuth, BASE_URL, API_COURSE_BASE_URL, API_CATEGORY_DASHBOARD, API_USER_COURSE_COUNT, API_BASE_URL } from "../../Util";
import Image from "../../Image";
import './Landingpage.css';
import { Link } from 'react-router-dom';
import store from 'store';
import $ from 'jquery';
import ReactPlayer from 'react-player'
import { FormatPrice } from  "../../Util";

let URL_IMG = '';
class LandingPage extends Home {
	constructor(props) {
		super(props);
		this.state = {
			courses: [], 
			courses_terlaris: [],
			categories: [], 
			facilitator: [], 
			contributor: [], 
			detail_facilitator: [], 
			detail_contributor: [], 
			countUserJoin: [], 
			countSertificate: [],
			getFavorite: [],
			user_review: [],
			detail_kisah_sukses: [],
			jumlahnya: 0,
			showVideo: false,
			max_ctitle_length: 45
		};
	}

	componentDidMount() {
		this.handleLoadData();
	}

	handleLoadData = () => {

		$.get(API_COURSE_BASE_URL, { journey: 1 })
			.then((data) => {
				let courseData = { courses: data.payload };
				store.set("course_data", courseData);
				this.setState(courseData);

			});

			$.get(API_BASE_URL + '/coursebestseller', { journey: 1 })
			.then((data) => {
				let courseData = { courses_terlaris: data.payload };
				store.set("course_terlaris", courseData);
				this.setState(courseData);

			});

		$.get(API_CATEGORY_DASHBOARD, { journey: 1 })
			.then((data) => {
				let categoryData = { categories: data.payload };
				store.set("category_data", categoryData);
				this.setState(categoryData);
			});

		// $.get(API_USER_COURSE_COUNT, {journey : 1})
		// .then((data) => {
		//   	let count_data = { countUserJoin: data.payload.userjoined,countSertificate: data.payload.certificate,getFavorite: data.payload.favourite_course };
		//   	store.set("category_data", count_data);
		//   	console.log("CATEGORY DATA LP >>> ", count_data);
		//   	this.setState(count_data);
		// });

	}

	//render course title
	renderCourseTitle = (title) => {
		return title.length < this.state.max_ctitle_length ? title : title.substring(0, this.state.max_ctitle_length) + "..."
	}

	getCourse = (bestSeller, courseMethod) => {
		let course_resource = (bestSeller) ? this.state.courses_terlaris : this.state.courses;
		let filteredCourses = courseMethod ? course_resource.filter(item => item.course_method === courseMethod)
        	: course_resource;
		course_resource.length > 3 ? course_resource.slice(0,3) : course_resource
		
		var course = (
			filteredCourses.slice(0, 3).map((item, index) => (
				<Col key={item.uuid || index}
					l={4}
					m={4}
					s={12}
					style={{display:'flex', justifyContent:'center', marginBottom:'20px'}}
				>
					<Link to={`/course/${item.slug}`}>
						<Card
							header={<CardTitle image={item.thumbnail_small}></CardTitle>}
							style={{margin:0}}
							className="card-course"
						>
							<div className="content-desktop" style={{maxHeight:'42px', overflowY:'hidden', fontWeight:"bolder"}}>{this.renderCourseTitle(item.title)}</div>
							<div className="content-mobile" style={{fontWeight:"bolder"}}>{item.title}</div>
								{
									item.review.rating != 0 ?
									<div style={{ display:"flex" }}>
										<StarRatings
											rating={item.review.rating}
											starDimension={"1rem"}
											starRatedColor={"#f2c94c"}
											starSpacing={"1px"}
										/>
										<p style={{lineHeight: "1.4rem", paddingLeft:"5px", fontSize:"12px", fontWeight:"bold"}}>{item.review.rating}</p>
									</div>
									:
										""
								}
							<div style={{ bottom: "0px", display:'flex', alignItems:'center', 'fontSize':"13px"}}>
								<img className="circle" style={{width:'30px', marginTop:'5px',marginBottom:'5px',marginRight:'4px'}} src={item.instructor_avatar} />
								 {item.instructor}
							</div>
							<div style={{ bottom: "0px" }}> { FormatPrice(item.final_price)}</div>
							<div style={{ bottom: "0px", backgroundColor: "#dddddd", width: "fit-content" }}> <h6 className="pad-xs">{ (item.course_method && item.course_method == 'spl') ? 'Kelas Mandiri':'Live Webinar' }</h6></div>
						</Card>
					</Link>
				</Col>
			))
		)
		return course;
	}

	onMediaAction = () => {
		this.setState({
			showVideo: false
		});
	}

	getFacilitator = () => {
		let img_path = `${process.env.PUBLIC_URL}`;

		var facilitator = (
			this.state.facilitator.map(item => (

				<Col
					l={4}
					m={4}
					s={12}
				>
					{/* <a href={'http://www.geti.id/v1/read_facilitator/teacher/' + item.id_artikel} target='_blank'> */}

					<Card onClick={() => this.clikDetailFacilitator(item.id_artikel)}
						style={{ cursor: 'pointer' }}
						closeIcon={<Icon>close</Icon>}
						// header={<CardTitle image={ 'http://geti.id/files/media/' + item.foto }></CardTitle>}
						header={<CardTitle image={`${img_path}/landing_page/${item.foto}`}></CardTitle>}
						className="card-facilitator-contributor"
					>
						<p style={{ fontWeight: "bold" }}>{item.judul}</p>
						{item.subjudul}
					</Card>
				</Col>
			))
		)
		return facilitator;
	}

	getContributor = () => {
		let img_path = `${process.env.PUBLIC_URL}`;
		var contributors = (
			this.state.contributor.map(item => (
				<Col
					l={4}
					m={4}
					s={12}
				>
					<Card onClick={() => this.clikDetailContributor(item.id_artikel)}
						style={{ cursor: 'pointer' }}
						closeIcon={<Icon>close</Icon>}
						// header={<CardTitle image={ 'http://geti.id/files/media/' + item.foto }></CardTitle>}
						header={<CardTitle image={`${img_path}/landing_page/${item.foto}`}></CardTitle>}
						className="card-facilitator-contributor"
					>
						<p style={{ fontWeight: "bold" }}>{item.judul}</p>
						{item.subjudul}
					</Card>
				</Col>

			))
		)
		return contributors;
	}

	getUserJoin = () => {
		// var 	bilangan = 23456789;

		// var	reverse = bilangan.toString().split('').reverse().join(''),
		// 	ribuan 	= reverse.match(/\d{1,3}/g);
		// 	ribuan	= ribuan.join('.').split('').reverse().join('');

		let countcourse = this.state.countUserJoin;
		var dataCountingCourse = (
			countcourse.map(item => item.total_count)
		)
		const numb = parseInt(dataCountingCourse);
		return this.formatRibuan(numb);
	}

	getCountSertificateCourse = () => {
		let countcourse = this.state.countSertificate;

		var dataCountingCourse = (
			countcourse.map(item => item.total_count)
		)
		// return dataCountingCourse;
		const numb = parseInt(dataCountingCourse);
		return this.formatRibuan(numb);
	}

	getFavoriteCourse = () => {
		let countcourse = this.state.getFavorite;

		var dataCountingCourse = (
			countcourse.map(item => (
				<li>
					<Link to={`/course/${item.title}`} style={{ color: '#1839f4', textDecoration: 'underline', fontWeight: 'bolder' }}>
						{item.title}
					</Link>
				</li>
			))
		)
		return dataCountingCourse;
	}

	formatRibuan = (numb) => {
		return parseFloat(numb).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
	}


	clikDetailFacilitator = (id_artikel) => {
		this.setState({ detail_facilitator: [] });
		$("#btn-modal-detail-contributor").trigger("click");
		$(".loading").hide();
		let all_facilitators = this.state.facilitator;
		let filter_data = all_facilitators.filter(val => val.id_artikel == id_artikel);
		this.setState({
			detail_facilitator: filter_data
		});

	}
	clikDetailContributor = (id_artikel) => {
		this.setState({ detail_facilitator: [] });
		$("#btn-modal-detail-contributor").trigger("click");
		$(".loading").hide();
		let all_contributor = this.state.contributor;
		let filter_data = all_contributor.filter(val => val.id_artikel == id_artikel);
		this.setState({
			detail_facilitator: filter_data
		});

	}

	clikDetailKisahSukses = (id_review) => {
		this.setState({ detail_kisah_sukses: [] });

		$("#btn-modal-kisah-sukses").trigger("click");
		$(".loading").hide();
		let all_user_review = this.state.user_review;
		let filter_data = all_user_review.filter(val => val.id == id_review);
		this.setState({
			detail_kisah_sukses: filter_data,
			showVideo: true
		});

	}



	render() {

		let imgTpl = (this.state.categories || []).map((image, index) => {
			return (
				<div key={image.Id} className="slick-kategory">
					{ image.id == 1
						?
						<div>
							<Link to={'/prakerja'}>
								<img src={image.icon_url} />
								<p className="categoryText">{image.name}</p>
								<p style={{ padding: "10px" }}>{image.title}</p>
							</Link>
							<div className="flex-jc-center">
								<Button variant="contained" color="primary">
									<a target="_blank" href='https://geti.id/prakerja' className="text-white">INFO SELENGKAPNYA</a>
								</Button>
							</div>
						</div>
						:
						<div>
						{/* <Link to={`/course/catalog?category_id=${image.id}`}> */}
							<Link to={`/course/catalog`}>
								<img src={image.icon_url} />
								<p className="categoryText">{image.name}</p>
								<p style={{ padding: "10px" }}>{image.title}</p>
								<div className="flex-jc-center">
									<Button variant="contained" color="primary">
										<span className="text-white">INFO SELENGKAPNYA</span>
									</Button>
								</div>
							</Link>
						</div>
					}
				</div>
			);
		});

		let list_kisah_sukses = (this.state.user_review || []).map((item, index) => {
			return (
				<div key={item.id} className="slick-kategory">
					<Row>
						<Col
							m={6}
							s={12}
						>
							<Card onClick={() => this.clikDetailKisahSukses(item.id)}
								closeIcon={<Icon>close</Icon>}
								header={<CardTitle image={`/img/kisah_sukses_testimoni/${item.images}`} />}
								horizontal
								revealIcon={<Icon>more_vert</Icon>}
								className="card-kisah-sukses"
							>
								<img onClick={() => this.clikDetailKisahSukses(item.id)} className="btnplay" src={`/img/play_button.png`} />
								<Row className="break-word">
										<div className="wrapper">
											<img className="circle imgProfile" src={`/img/kisah_sukses_testimoni/${item.images}`} />
											<div className="name">{item.name.substring(0, 50)}</div>

										</div>
										<div>
											<Col l={12} m={12} s={12}>
												<p className="review-detail break-word">{item.title.substring(0, 90)}
												</p>
											</Col>
										</div>
								</Row>
								{/* </h6> */}
							</Card>
						</Col>
					</Row>
				</div>
			);
		});

		const imgBanner = [
			{
				'key': '1',
				'img': '/img1/banner/slide/Banner_1.jpeg',
				'title': 'Kerja Lestari Academy',
				'a': '/',
			},
			{
				'key': '2',
				'img': '/img1/banner/slide/Banner_2.jpg',
				'title': 'yayasan',
				'target':'_blank',
				'a': 'https://anugerahcinta.org/ ',
			},
			{
				'key': '3',
				'img': '/img1/banner/slide/Banner_3.jpg',
				'title': 'Kerja Lestari Academy',
				'a': '/register',
			},
			{
				'key': '4',
				'img': '/img1/banner/slide/Banner_4.jpg',
				'title': 'Kerja Lestari Academy',
				'a': '/list-course',
			},
			{
				'key': '5',
				'img': '/img1/banner/slide/Banner_5.jpg',
				'title': 'Kerja Lestari Academy',
				'onClick': 'video-section',
				'a': '#',
			},
		];

		const mbImgBanner = [
			{
				'key': '1',
				'img': '/img1/banner/slide/mb_Banner_1.jpg',
				'title': 'Kerja Lestari Academy',
				'a': '/',
			},
			{
				'key': '1',
				'img': '/img1/banner/slide/mb_Banner_2.jpg',
				'title': 'Kerja Lestari Academy',
				'target':'_blank',
				'a': 'https://anugerahcinta.org/ ',
			},
			{
				'key': '1',
				'img': '/img1/banner/slide/mb_Banner_3.jpg',
				'title': 'Kerja Lestari Academy',
				'a': '/register',
			},
			{
				'key': '1',
				'img': '/img1/banner/slide/mb_Banner_4.jpg',
				'title': 'Kerja Lestari Academy',
				'a': '/list-course',
			},
			{
				'key': '1',
				'img': '/img1/banner/slide/mb_Banner_5.jpg',
				'title': 'Kerja Lestari Academy',
				'onClick': 'video-section',
				'a': '#',
			},
		];

		const sectionname = {
			color: "#df2e2e",
			margin: "20px",
			padding: "20px",
			fontSize: "1.5em",
			fontWeight: "bold",
			textAlign: "center",
			display : "flex",
			alignItems : "center",
			justifyContent : "center"
		};

		const customcolor = {
			color: "#00ffc6",
			fontFamily: "Trap, sans-serif"
		};

		const bannerSection = {
			color: "#df2e2e",
			padding: "40px",
			fontSize: "1.5em",
			fontWeight: "bold",
			textAlign: "center"
		};

		const video = {
			width: "100%",
			height: "500px",
			border: "0"
		};

		const icontitle = {
			padding: "10px",
			fontSize: "18px",
			fontWeight: "700",
			color: "#8388BF",
			textAlign: "left"
		}

		const icontext = {
			fontSize: "10px",
			lineHeight: "1.5",
			paddingLeft: "10px",
			textAlign: "left"
		}

		const iconcolumn = {
			padding: "10px"
		}

		const article = {
			border: "1px solid #ccc",
			borderRadius: "5px",
			backgroundColor: "#FFFFFF",
			height: "550px",
			width: "550px",
		}

		const playerwrapper = {
			position: "relative",
			paddingTop: "2%" /* 720 / 1280 = 0.5625 */
		}

		const reactplayer = {
			position: "1px solid #ccc",
			absolute: "5px",
			top: '0',
			left: '0',
		}

		const settings = {
			draggable: true,
			dots: false,
			autoplay: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1
		};

		const settings_category = {
			dots: false,
			autoplay: true,
			infinite: true,
			slidesToShow: 2,
			slidesToScroll: 2,
			responsive: [
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						initialSlide: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		};

		const style_kisah_sukses = {
			dots: false,
			autoplay: false,
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 4,
			responsive: [
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
						initialSlide: 4
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		};

		let BannerCekSertifikat = () => (
			<div style={{ position: "relative",  display:'flex', justifyContent:'center', marginTop:'20px' }} className="banner-lg">
				<img 
					src="/img1/banner/redeem_voucher.jpg" 
					className="bg-white"
					alt="Background Banner untuk Cek Sertifikat"
					style={{ 
						width: "98%",
						height: "auto",
						zIndex: "-1",
						borderRadius: "10px"
					}}
				/>
				<div>
					<h5 style={{
						fontSize: "1.8vw",
						color: "white",
						position: "absolute",
						top: "40%",
						left: "18%"
					}}>
						{/* Text Placeholder */}
					</h5>
					<a href="/prakerja" target="_blank">
						<img 
							src="/img1/banner/Redeem_disini.png" 
							alt="Tombol untuk Redeem"
							style={{ 
								width: "14%",
								height: "auto",
								position: "absolute",
								top: "18%",
								left: "60%",
								cursor: "pointer",
								borderRadius: "8px",
								transition: "0.3s"
							}}
						/>
					</a>
				</div>
			</div>
		);
		
		let MbBannerCekSertifikat = () => (
			<div style={{ position: "relative",  display:'flex', justifyContent:'center', marginTop:'10px' }}>
				<img 
					className="bg-white"
					src="/img1/banner/mb_redeem_voucher.jpeg" 
					alt="Background Banner untuk Mobile"
					style={{ width: "98%", height: "auto", borderRadius: '10px' }}
				/>
				<div>
					<h5 style={{
						fontSize: "4vw",
						color: "white",
						position: "absolute",
						top: "35%",
						left: "30%",
						transform: "translate(-22%, -50%)"
					}}>
						{/* Text Placeholder */}
					</h5>
					<a href="/prakerja" target="_blank">
						<img 
							src="/img1/banner/Redeem_disini.png" 
							alt="Tombol untuk Redeem"
							style={{ 
								width: "30%",
								height: "auto",
								position: "absolute",
								top: "20%",
								left: "55%",
								cursor: "pointer",
								borderRadius: "8px",
								transition: "0.3s"
							}}
						/>
					</a>
				</div>
			</div>
		);
		
		let MidBannerCekSertifikat = () => (
			<div style={{ position: "relative",  display:'flex', justifyContent:'center', marginTop:'10px' }}>
				<img 
					className="bg-white"
					src="/img1/banner/redeem_voucher.jpg" 
					alt="Background Banner untuk Tablet"
					style={{ width: "98%", height: "auto", borderRadius:'10px' }}
				/>
				<div>
					<h3 style={{
						fontSize: "4vw",
						color: "white",
						position: "absolute",
						top: "35%",
						left: "30%",
						transform: "translate(-22%, -50%)"
					}}>
						{/* Text Placeholder */}
					</h3>
					<a href="/prakerja" target="_blank">
						<img 
							src="/img1/banner/Redeem_disini.png" 
							alt="Tombol untuk Redeem"
							style={{ 
								width: "18%",
								height: "auto",
								position: "absolute",
								top: "5%",
								left: "60%",
								cursor: "pointer",
								borderRadius: "8px",
								transition: "0.3s"
							}}
						/>
					</a>
				</div>
			</div>
		);

		let announcement = this.state.announcement;
		let user_review_data = this.state.user_review;
		let isLogin = CheckAuth() != "";

		return (
			<div style={{position:'relative', overflow:'hidden'}}>
				<div style={{
					position:'absolute',
					top:'25%'
				}}>
					<img 
						style={{
							position:'absolute', 
							width:'150px',
							left:'25px',
							zIndex:3,
						}}
						src="/img1/ornament/Banner-06.png" 
					/>
					<img 
						style={{
							position:'absolute', 
							width:'200px',
							top:'-3px',
							left:'-35px',
							zIndex:2,
						}}
						src="/img1/ornament/strip-right.jpg" 
					/>
				</div>
				<div style={{
					position:'absolute',
					top:'45%',
					right:'15%'
				}}>
					<img 
						style={{
							position:'absolute', 
							width:'150px',
							zIndex:3,
						}}
						src="/img1/ornament/Banner-09.png" 
					/>
					<img 
						style={{
							position:'absolute', 
							width:'200px',
							top:'4px',
							right:'-220px',
							zIndex:2,
						}}
						src="/img1/ornament/strip-left.jpg" 
					/>
				</div>
				<div style={{
					position:'absolute',
					top:'68%'
				}}>
					<img 
						style={{
							position:'absolute', 
							width:'150px',
							left:'25px',
							zIndex:3,
						}}
						src="/img1/ornament/Banner-06.png" 
					/>
					<img 
						style={{
							position:'absolute', 
							width:'200px',
							top:'-3px',
							left:'-35px',
							zIndex:2,
						}}
						src="/img1/ornament/strip-right.jpg" 
					/>
				</div>
				<div className="container banner hide-on-small-only">
					<Slider {...settings}>
						{imgBanner.map((item, index) => (
							<div key={item.id || index}>
								<a href={item.a} target={item.target} onClick={() => item.onClick ? this.handleClickBanner(item.onClick) : null}>
									<img src={BASE_URL + item.img} alt={item.title} />
								</a>
							</div>
						))}
					</Slider>
				</div>

				<div className="container banner hide-on-med-and-up">
					<Slider {...settings}>
						{mbImgBanner.map((item, index) => (
							<div key={item.id || index}>
								<a href={item.a} target={item.target} onClick={() => item.onClick ? this.handleClickBanner(item.onClick):null}>
									<img src={BASE_URL + item.img} alt={item.title} />
								</a>
							</div>
						))}
					</Slider>
				</div>

				<div className="hide-on-med-and-down">
					{BannerCekSertifikat()}
				</div>
				<div className="hide-on-med-and-up">
					{MbBannerCekSertifikat()}
				</div>
				<div className="hide-on-large-only hide-on-small-only">
					{MidBannerCekSertifikat()}
				</div>

				<div className="bg-white pad-xs fadeIn wow">
					<div style={sectionname}>
						<img 
							style={{width:'30px', marginRight: '10px'}}
							src="/img1/ornament/Banner-12.png"
						/>
						<h4 style={{marginBottom:0}}>Kelas Terlaris</h4>
						<img 
							style={{width:'30px'}}
							src="/img1/ornament/Banner-13.png"
						/>
					</div>
					<div className="container">
						<Row>
							{this.getCourse(1)}
						</Row>
						<Row>
							<Col s={12} m={12} l={12} style={{ textAlign: "center", fontSize: "18px", color: "#8388BF", fontWeight: "700", paddingTop: "20px" }}>
								<Link to={`/list-course`}>Lihat Lebih Banyak</Link>
							</Col>
						</Row>
					</div>
				</div>

				<div className="bg-white pad-xs fadeIn wow">
					<div style={sectionname}>
						<img 
							style={{width:'30px'}}
							src="/img1/ornament/Banner-12.png"
						/>
						<h4 style={{marginBottom:0}}>Daftar Kelas Pembelajaran Mandiri</h4>
						<img 
							style={{width:'30px'}}
							src="/img1/ornament/Banner-13.png"
						/>
					</div>
					<div className="container">
						<Row>
							{this.getCourse(0, 'spl' )}
						</Row>
						<Row>
							<Col s={12} m={12} l={12} style={{ textAlign: "center", fontSize: "18px", color: "#8388BF", fontWeight: "700", paddingTop: "20px" }}>
								<Link to={`/list-course?t=spl`}>Lihat Lebih Banyak</Link>
							</Col>
						</Row>
					</div>
				</div>

				<div className="bg-white pad-xs fadeIn wow">
					<div style={sectionname}>
						<img 
							style={{width:'30px'}}
							src="/img1/ornament/Banner-12.png"
						/>
						<h4 style={{marginBottom:0}}>Daftar Kelas Webinar</h4>
						<img 
							style={{width:'30px'}}
							src="/img1/ornament/Banner-13.png"
						/>
					</div>
					<div className="container">
						<Row>
							{this.getCourse(0, 'webinar')}
						</Row>
						<Row>
							<Col s={12} m={12} l={12} style={{ textAlign: "center", fontSize: "18px", color: "#8388BF", fontWeight: "700", paddingTop: "20px" }}>
								<Link to={`/list-course?t=webinar`}>Lihat Lebih Banyak</Link>
							</Col>
						</Row>
					</div>
				</div>
				{/* <div className="bg-white pb-l pt-m" id="video-section" style={{textAlign:'center'}}>
					<div style={sectionname}><h4>Video Tutorial Kelas GeTI Online</h4></div>
					<Row className="container">
						<Col s={12} m={6} l={6} className="fadeIn wow">
							<iframe src="https://www.youtube.com/embed/L7iZPrVXC9I" frameBorder="0" allowFullScreen={true}></iframe>
							<div>Pendaftaran Akun dan Redeem Voucher</div>
						</Col>
						<Col s={12} m={6} l={6} className="fadeIn wow">
							<iframe src="https://www.youtube.com/embed/Nak_UFj7-AA" frameBorder="0" allowFullScreen={true}></iframe>
							<div>Isi Kuis</div>
						</Col>
						<Col s={12} m={6} l={6} className="fadeIn wow">
							<iframe src="https://www.youtube.com/embed/yQXQyMVsvH4" frameBorder="0" allowFullScreen={true}></iframe>
							<div>Rating Kelas</div>
						</Col>
						<Col s={12} m={6} l={6} className="fadeIn wow">
							<iframe src="https://www.youtube.com/embed/7-EyBoOGiJs" frameBorder="0" allowFullScreen={true}></iframe>
							<div>e-Sertifikat</div>
						</Col>
						<Col s={12} m={6} l={6} className="fadeIn wow">
							<iframe src="https://www.youtube.com/embed/KT9rC4bQJ3g" frameBorder="0" allowFullScreen={true}></iframe>
							<div>Unduh e-Sertifikat</div>
						</Col>
					</Row>
				</div> */}
				<div className="bg-white pb-l pt-m" id="video-section" style={{textAlign:'center'}}>
					<div style={sectionname}><h4>Video Panduan Pelatihan</h4></div>
					<Row className="container">
						<Col s={12} m={6} l={6} className="fadeIn wow">
							{/* <iframe src="https://www.youtube.com/embed/e6UddMXlWds" frameBorder="0" allowFullScreen={true}></iframe>
							<div>Pendaftaran Akun dan Redeem Voucher</div> */}
							<iframe src="https://youtube.com/embed/Ut8AmKYU_WQ" frameBorder="0" allowFullScreen={true}></iframe>
							<div>Cara membuat akun di LMS Kerja Lestari Academy</div>
						</Col>
						<Col s={12} m={6} l={6} className="fadeIn wow">
							{/* <iframe src="https://www.youtube.com/embed/Nak_UFj7-AA" frameBorder="0" allowFullScreen={true}></iframe>
							<div>Isi Kuis</div> */}
							<iframe src="https://www.youtube.com/embed/VyKR-Pp-cjo" frameBorder="0" allowFullScreen={true}></iframe>
							<div>Cara redeem voucher di LMS Kerja Lestari Academy</div>
						</Col>
						{/* <Col s={12} m={4} l={4} className="fadeIn wow">
							<iframe src="https://www.youtube.com/embed/yQXQyMVsvH4" frameBorder="0" allowFullScreen={true}></iframe>
							<div>Rating Kelas</div>
						</Col> */}
					</Row>
					
				</div>

				{/* MODAL POP UP DETAIL*/}
				<Modal trigger={<Button className="hide" id="btn-modal-detail-contributor" />}
					modalOptions={{ dismissible: true }}
					options={{
						endingTop: '10%',
						inDuration: 250,
						onCloseEnd: null,
						onCloseStart: null,
						onOpenEnd: null,
						onOpenStart: null,
						opacity: 0.5,
						outDuration: 250,
						preventScrolling: true,
						startingTop: '4%'
					}}
				>
					<div className="center almost-full">
						<div className="mb-m">
							<div className="container facilitator">
								<div className="top-right-button">
									<a className="modal-close">
										{" "}
										<i className="fa fa-close" />{" "}
									</a>
								</div>
								<Col
									l={6}
									m={6}
									s={12}
								>
									{
										this.state.detail_facilitator ? this.state.detail_facilitator.map(val => {
											return (
												<div>
													<div>
														<img src={`${process.env.PUBLIC_URL}/landing_page/${val.foto}`} style={{ width: '250px', height: '250px', borderRadius: '150px' }} />
													</div>

													<div className="text-justify" >
														<h5>{val.judul} </h5>
														<h6>{val.subjudul} </h6>
														<hr />
														<p>{val.kilasan}</p>
													</div>
												</div>
											)
										}) : ''
									}

								</Col>
							</div>
						</div>
					</div>
				</Modal>

				{/* MODAL POP UP KISAH SUKSES*/}
				<Modal trigger={<Button className="hide" id="btn-modal-kisah-sukses" />}
					modalOptions={{ dismissible: true }}
					id="modal-kisah-sukses"
					options={{
						endingTop: '10%',
						inDuration: 250,
						onCloseEnd: null,
						onCloseStart: null,
						onOpenEnd: null,
						onOpenStart: null,
						opacity: 0.5,
						outDuration: 250,
						preventScrolling: true,
						startingTop: '4%'
					}}
				>
					{/* <div className="center full"> */}
					{/* <div className="mb-m"> */}
					{/* <div className="container facilitator"> */}
					<div className="top-right-button">
						<a className="modal-close" onClick={() => this.onMediaAction()}>
							{" "}
							<i className="fa fa-close" />{" "}
						</a>
					</div>



					<Row>
						{
							this.state.detail_kisah_sukses ? this.state.detail_kisah_sukses.map(val => {
								return (
									<span>
										{/* <Row style={{marginLeft:'-10px'}}> */}
										<Col className="col-images-review" l={6} m={6} s={12}>
											{/* <img  src={`/img/kisah_sukses_testimoni/${val.images}`} /> */}
											<div className="video-comment">
												{/* <iframe src="https://www.youtube.com/embed/y6is0GLW7SU?autoplay=1&controls=0" width="480" height="400" frameBorder="0" allowFullScreen={true}></iframe> */}
												<div className='player-wrapper' style={playerwrapper}>
													<ReactPlayer style={reactplayer}
														url={val.video}
														// url='/video/video1.mp4'
														className='react-player ReactPlayerBox'
														playing={this.state.showVideo}
														width='400px'
														height='400px'
														controls={true}
													// onPause={(evntState) => this.onMediaAction(evntState)}
													// onPlay={(evntState) => this.onMediaAction(evntState)}
													/>
												</div>
											</div>

										</Col>
										<Col className="col-images-review-content" id="col-images-review-content" l={6} m={6} s={12}>
											<h4>{val.title}</h4>
											<p>{val.comment}</p>

											<div className="wrapper-parent">
												<Row className="wrapper">
													<img className="circle review-item" src={`/img/kisah_sukses_testimoni/${val.images}`} width="30" height="30"/>
													<span className="review-item review-name">{val.name}</span>
												</Row>
											</div>
										</Col>
										{/* </Row> */}

										{/* <Card style={{boxShadow:'none'}}
														
														header={<CardTitle image={`${process.env.PUBLIC_URL}/landing_page/${val.foto}`}></CardTitle>}
													>
													</Card> */}
									</span>
								)
							}) : ''
						}

					</Row>
					{/* </div> */}
					{/* </div> */}
					{/* </div> */}
				</Modal>

			</div>
		);
	}
}


class Testimonial extends React.Component {
	render() {
		return (
			<div>
				<p className="h5 font-grey container-small mb-s mnt-m">
					{this.props.content}
				</p>
				<Image
					src={this.props.avatar}
					className="medium center avatar circle mb-s"
				/>
				<h5 className="font-orange">{this.props.user}</h5>
				<div className="font-grey">{this.props.role}</div>
			</div>
		);
	}
}


export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/Public/Home/LandingPage.js